// Chakra imports
import {
  Heading,
  Box,
  SimpleGrid,
  Text,
  HStack,
  VStack,
  Icon,
  Button,
  Card,
  Flex,
  useColorModeValue,
  useOutsideClick,
} from "@chakra-ui/react";

import "../analytics.css";

import { RadialChart } from "react-vis";
import { FiSunrise, FiSunset, FiPhoneOff, FiCalendar } from "react-icons/fi";
import { MdCall } from "react-icons/md";

import MiniCalendar from "components/calendar/MiniCalendar";
import AnalyticsTable from "views/admin/niclAnalytics/components/AnalyticsTable";
import AnalyticsTablePolicyRenewal from "views/admin/niclAnalytics/components/AnalyticsTablePolicyRenewal";
import ZetScenarioId5Table from "views/admin/niclAnalytics/components/ZetScenarioId5Table"
import UnAnswereAnalyticsTable from "views/admin/niclAnalytics/components/UnAnswereAnalyticsTable";
import {
  MorningCallTableColumns,
  EveningCallTableColumns,
  UnansweredCallTableColumns,
  INCCallTableColumns,
  IPACCallTableColumns,
  NICLAnalyticsColumn,
} from "views/admin/niclAnalytics/variables/columnsData";
import tableDataDev from "views/admin/niclAnalytics/variables/tableDataDevelopment.json";

import { React, useEffect, useState, useRef } from "react";
import Chart from "react-apexcharts";

import { useSelector, useDispatch } from "react-redux";
// import { setLoader } from "../../../redux/actions/loader";
import {
  getAnalyticsDataAction,
  getAnalyticsCallBreakDownDataAction,
  getAnalyticsDataEveningAction,
  putEditAnalyticsDataAction,
  getAnalyticsDataActionINC,
  getAnalyticsCallBreakDownDataActionINC,
  getAnalyticsUnansweredDataAction,
} from "../../../../redux/actions/analytics";
import * as type from "../../../../redux/types";
import {
  removeUnderscore,
  ROLE_ACCESS,
  removeUnderscoreIPAC,
} from "utils/Utils";
import moment from "moment";
import { policyRenewalColumn } from "../variables/columnsData";
const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

export default function ZetScenario5Dashboard(props) {
  const dispatch = useDispatch();
  const [analyticsTablePageNo, setAnalyticsTablePageNo] = useState(1);
  const [pageLimitanalyticsTable, setLimitAnalyticsTable] = useState(10);
  const [analyticsFilter, setAnalyticsFilter] = useState({
    isfilter: false,
    phoneNumber: "",
    customerName: "",
    productName: "",
    language: "",
    agentName: "",
    sendSms: "",
  });
  const [unansweredTablePageNo, setUnansweredsTablePageNo] = useState(1);
  const [pageLimitUnansweredTable, setLimitUnansweredTable] = useState(10);
  const [unansweredFilter, setUnansweredFilter] = useState({
    isfilter: false,
    phoneNumber: "",
  });
  const userData = useSelector((state) => state.userData);
  const analyticsAll = useSelector((state) => state.analyticsData);
  const callBreakDownData = useSelector(
    (state) => state.analyticsData.callBreakDownData.callAnalytics
  );
  const analyticsData = useSelector(
    (state) => state.analyticsData.analyticsTableProperties
  );
  const unansweredCallUserDetails = useSelector((state) =>
    state.analyticsData.callBreakDownData?.unansweredCallUserDetails
      ? state.analyticsData.callBreakDownData?.unansweredCallUserDetails
      : []
  );

  const unansweredUserData = useSelector(
    (state) => state.analyticsData.analyticsTableUnansweredProperties
  );
  console.log("Filter data", analyticsFilter);
  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      // invokedGetAnalyticsApiDataCall();
      dispatch(
        getAnalyticsDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0005",
          limit: pageLimitanalyticsTable,
          page: analyticsTablePageNo,
          token: userData.token,
          ...analyticsFilter,
        })
      );
      dispatch(
        getAnalyticsCallBreakDownDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0005",
          token: userData.token,
        })
      );
      dispatch(
        getAnalyticsUnansweredDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0005",
          limit: pageLimitUnansweredTable,
          page: unansweredTablePageNo,
          token: userData.token,
        })
      );
    }
    // invokedGetAnalyticsApiDataCall()
  }, [props.selectedDateRange]);

  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      dispatch(
        getAnalyticsDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0005",
          limit: pageLimitanalyticsTable,
          page: analyticsTablePageNo,
          token: userData.token,
          ...analyticsFilter,
        })
      );
    }
    // invokedGetAnalyticsApiDataCall()
  }, [analyticsTablePageNo, pageLimitanalyticsTable]);

  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      dispatch(
        getAnalyticsUnansweredDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0005",
          limit: pageLimitUnansweredTable,
          page: unansweredTablePageNo,
          token: userData.token,
        })
      );
    }
    // invokedGetAnalyticsApiDataCall()
  }, [unansweredTablePageNo, pageLimitUnansweredTable]);

  const applyFilterAnalytisData = () => {
    setAnalyticsFilter({
      ...analyticsFilter,
      isfilter: true,
      
    });
    dispatch(
      getAnalyticsDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: "P0005",
        limit: pageLimitanalyticsTable,
        page: analyticsTablePageNo,
        token: userData.token,
        ...analyticsFilter,
        isfilter:true
      })
    );
  };

  const discardFilterAnalytisData = () => {

    dispatch(
      getAnalyticsDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: "P0005",
        limit: pageLimitanalyticsTable,
        page: analyticsTablePageNo,
        token: userData.token,
      })
    );
    setAnalyticsFilter({
      isfilter: false,
      phoneNumber: "",
      customerName: "",
      productName: "",
      language: "",
      agentName: "",
      sendSms: "",
    });
  };

  const applyFilteUnansweredData = () => {
    dispatch(
      getAnalyticsUnansweredDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: "P0005",
        limit: pageLimitUnansweredTable,
        page: unansweredTablePageNo,
        token: userData.token,
        ...unansweredFilter
      })
    );
  };

  const discardFilterUnansweredData = () => {
    dispatch(
      getAnalyticsUnansweredDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: "P0005",
        limit: pageLimitUnansweredTable,
        page: unansweredTablePageNo,
        token: userData.token,
      })
    );
    setUnansweredFilter({ isfilter: false, phoneNumber: "" });
  };

  // console.log("Analytics data from view--->",analyticsAll)
  return (
    <>
      <HStack spacing="12px" className="sbscoAnalyticsDBContainer">
        <Box className="dbBlock" w="35%" h="200px" bg="white">
          <Heading as="h6" size="xs" m="12px">
          Magnet Month
          </Heading>
          <HStack>
            <div className="radialChart">
              <RadialChart
                data={[
                  {
                    angle:
                      (callBreakDownData?.callCompleted /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#0079EA",
                  },
                  {
                    angle:
                      (callBreakDownData?.callIncompleted /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#7EBAF3",
                  },
                  {
                    angle:
                      (callBreakDownData?.totalUnanswered /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#E4F0FB",
                  },
                ]}
                width={160}
                height={160}
                colorType="literal"
              />
              <div className="radialText">
                <p>Total calls</p>
                <h4>{callBreakDownData?.totalCallAttempt}</h4>
              </div>
            </div>
            <VStack
              spacing={2}
              align="left"
              position="relative"
              className="donutChartContent"
            >
              <Box display={"flex"} className="dchartBlock">
                <Box h="10px" w="10px" bg="#0079EA" />
                <Text fontSize="10px" ml="2px" className="text1">
                  Completed the call
                </Text>
                <Text fontWeight="bold" position="absolute" right="4px">
                  {callBreakDownData?.callCompleted}
                  {/* 62 */}
                </Text>
              </Box>
              <Box display={"flex"} className="dchartBlock">
                <Box h="10px" w="10px" bg="#7EBAF3" />
                <Text fontSize="10px" mr="2px" className="text1">
                  Answered call but didn't complete
                </Text>
                <Text fontWeight="bold" position="absolute" right="4px">
                  {callBreakDownData?.callIncompleted}
                </Text>
              </Box>
              <Box display={"flex"} className="dchartBlock">
                <Box h="10px" w="10px" bg="#E4F0FB" />
                <Text fontSize="10px" ml="2px" className="text1">
                  Didn't answer call
                </Text>
                <Text fontWeight="bold" position="absolute" right="4px">
                  {callBreakDownData?.totalUnanswered}
                </Text>
              </Box>
            </VStack>
          </HStack>
        </Box>

        <Box
          className="dbBlock smBlock"
          w="21%"
          h="200px"
          bg="white"
          position="relative"
        >
          <Text
            fontSize="xs"
            fontWeight="bold"
            m="12px"
            style={{ fontSize: "17px", fontWeight: "550" }}
          >
            Total number of successful calls made by Telephony
          </Text>
          <Heading as="h6" size="xl" m="12px" pos="absolute" bottom="0">
            {callBreakDownData?.successfulCall}
          </Heading>
          <Icon
            as={MdCall}
            width="30px"
            height="30px"
            color="grey"
            position="absolute"
            right="20px"
            bottom="15px"
          />
        </Box>
        <Box
          className="dbBlock smBlock"
          m="10px"
          w="21%"
          h="200px"
          bg="white"
          position="relative"
        >
          <Text
            fontSize="xs"
            fontWeight="bold"
            m="12px"
            style={{ fontSize: "17px", fontWeight: "550" }}
          >
            Not able to reach (Customer didn't pick up or not reachable)
          </Text>
          <Heading as="h6" size="xl" m="12px" pos="absolute" bottom="0">
            {callBreakDownData?.totalUnanswered}
          </Heading>
          <Icon
            as={FiPhoneOff}
            width="24px"
            height="24px"
            color="grey"
            position="absolute"
            right="20px"
            bottom="17px"
          />
        </Box>
        <Box
          className="dbBlock smBlock"
          m="10px"
          w="21%"
          h="200px"
          bg="white"
          position="relative"
        >
          <Text
            fontSize="xs"
            fontWeight="bold"
            m="12px"
            style={{ fontSize: "17px", fontWeight: "550" }}
          >
            DnD Numbers
          </Text>
          <Heading as="h6" size="xl" m="12px" pos="absolute" bottom="0">
            {props.dndNumberData?.length}
          </Heading>
          <Button
            size="sm"
            backgroundColor="#e887cc"
            // leftIcon={<MdDownload />}
            onClick={() => {
              // handleDownloadExcel();
            }}
          >
            Export Dnd List
          </Button>
        </Box>
      </HStack>

      <Box className="sbscoTable">
        <SimpleGrid
          mb="20px"
          columns="1"
          spacing={{ base: "20px", xl: "20px" }}
        >
          <div className="sbscoTableContainer mcaTable">
            <ZetScenarioId5Table
              title={"Magnet Month"}
              columnsData={policyRenewalColumn}
              tableData={analyticsData}
              isEvening={false}
              setAnalyticsTablePageNo={setAnalyticsTablePageNo}
              analyticsTablePageNo={analyticsTablePageNo}
              pageLimitanalyticsTable={pageLimitanalyticsTable}
              setLimitAnalyticsTable={setLimitAnalyticsTable}
              analyticsFilter={analyticsFilter}
              setAnalyticsFilter={setAnalyticsFilter}
              applyFilterAnalytisData={applyFilterAnalytisData}
              discardFilterAnalytisData={discardFilterAnalytisData}
              selectedDateRange={props.selectedDateRange}
              //   updateAnalyticsValue={updateAnalyticsValue}
            />
          </div>
          <div className="sbscoTableContainer ucaTable">
            <UnAnswereAnalyticsTable
              title={"Unanswered Call Analysis"}
              columnsData={UnansweredCallTableColumns}
              tableData={unansweredUserData}
              unansweredTablePageNo={unansweredTablePageNo}
              setUnansweredsTablePageNo={setUnansweredsTablePageNo}
              pageLimitUnansweredTable={pageLimitUnansweredTable}
              setLimitUnansweredTable={setLimitUnansweredTable}
              unansweredFilter={unansweredFilter}
              setUnansweredFilter={setUnansweredFilter}
              applyFilteUnansweredData={applyFilteUnansweredData}
              discardFilterUnansweredData={discardFilterUnansweredData}
              selectedDateRange={props.selectedDateRange}
              scenarioId="P0005"
            />
          </div>
        </SimpleGrid>
      </Box>
    </>
  );
}
